const GrimacingIcon = /*#__PURE__*/ [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 15C7 13.5949 7.70031 13 9 13H15C16.2997 13 17 13.5949 17 15C17 16.4051 16.2997 17 15 17H9C7.70031 17 7 16.4051 7 15Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.00897 9L8 9M16 9L15.991 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", key: "2" }]
];

export { GrimacingIcon as default };
//# sourceMappingURL=GrimacingIcon.js.map
